import { typography } from '@material-ui/system'
import { palette } from '@procurify/ui-theme'
import styled from 'styled-components'

import { type IPriceProps } from '../Price'

export const PriceStyled = styled.div<Partial<IPriceProps>>`
  font-size: 1em;
  font-weight: ${(props) => props.theme.fontWeights.semibold};
  white-space: nowrap;

  ${typography}
  ${palette};
`
